export default __webpack_public_path__ + "static/media/landing_blue_papper_airplane.d1b0f5c3.png";